import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceProduct($id: ID!, $shop: Int!) {
    marketplaceProduct: marketplaceProductByVariantGroupCode(
      id: $id
      shop: $shop
    ) {
      id
      title
      description
      careInstructions
      warnings
      warranty
      brand
      category {
        path {
          code
          title
        }
      }
      options {
        id
        type
        displayName
        visualGuide {
          name
          url
          description
        }
        values {
          id
          label
          colourHexCode
        }
      }
      variants {
        id
        objectID
        title
        originalPrice
        discountPrice
        returnable
        sku
        variantGroupCode
        quantity
        createdAt
        promotions {
          campaignId
          title
          directPromotion {
            sys {
              id
            }
            title
            slug
            talonOneId
            termsAndConditions
          }
        }
        images {
          url
          description
        }
        optionValues {
          id
          optionId
          value
          displayName
        }
        issues {
          severity
          type
        }
        information {
          ... on MarketplaceProductInformationText {
            label
            text
          }
          ... on MarketplaceProductInformationTable {
            label
            entries {
              label
              text
            }
          }
        }
      }
    }
    marketplaceShop(id: $shop) {
      id
      name
      tradingState
      retailer {
        sys {
          id
        }
        slug
        retailerSizeGuide
        retailerLogoSet {
          coloured {
            url
          }
        }
      }
    }
    marketplaceShippingConfiguration {
      shippingCost
    }
  }
`
